import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthService, LoggerService, tryNormalizeHttpError } from '@spartacus/core';
import { exhaustMap, of, switchMap } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import { DpMeasurementSystemsApiService } from '../../services/measurement-systems-api.service';
import { MeasurementSystemsActions } from '../actions/measurement-systems.action';

export const loadMeasurementSystemsEffect$ = createEffect(
  (actions$ = inject(Actions), apiService = inject(DpMeasurementSystemsApiService), logger = inject(LoggerService)) =>
    actions$.pipe(
      ofType(MeasurementSystemsActions.loadMeasurementSystems),
      exhaustMap(() =>
        apiService.getMeasurementSystems().pipe(
          map((payload) => MeasurementSystemsActions.loadMeasurementSystemSuccess({ payload })),
          catchError((error) =>
            of(MeasurementSystemsActions.loadMeasurementSystemsFail({ payload: tryNormalizeHttpError(error, logger) }))
          )
        )
      )
    ),
  { functional: true }
);

export const activeMeasurementSystemEffect$ = createEffect(
  (
    actions$ = inject(Actions),
    authService = inject(AuthService),
    apiService = inject(DpMeasurementSystemsApiService),
    logger = inject(LoggerService)
  ) =>
    actions$.pipe(
      ofType(MeasurementSystemsActions.changeActiveMeasurementSystem),
      switchMap(({ payload }) =>
        authService.isUserLoggedIn().pipe(
          take(1),
          switchMap((isLoggedIn) =>
            isLoggedIn
              ? apiService.setActiveMeasurementSystem(payload).pipe(
                  map(() => MeasurementSystemsActions.setActiveMeasurementSystem({ payload })),
                  catchError((error) =>
                    of(
                      MeasurementSystemsActions.changeActiveMeasurementSystemFail({
                        payload: tryNormalizeHttpError(error, logger)
                      })
                    )
                  )
                )
              : of(MeasurementSystemsActions.setActiveMeasurementSystem({ payload }))
          )
        )
      )
    ),
  { functional: true }
);
